import { AxiosResponse } from 'axios';
import { appContextGet } from './httpCommon/appAxios.service';
import { MAINTENANCE_TYPES_ENDPOINTS } from '../constants/apiEndpoints';
import { PagedResponse, StandardParams } from '../types/interfaces';
import { MaintenanceType } from '../types/interfaces/accountTankMaintenance.interfaces';

export const getDefaultMaintenanceType = (): Promise<AxiosResponse<MaintenanceType>> => {
  return appContextGet(MAINTENANCE_TYPES_ENDPOINTS.DEFAULT);
};

export const getMaintenanceTypes = (
  params?: StandardParams,
): Promise<AxiosResponse<MaintenanceType[] | PagedResponse<MaintenanceType>>> => {
  return appContextGet(MAINTENANCE_TYPES_ENDPOINTS.BASE, params);
};
